export const STATUS_META = {
  waiting: { label: "En attente", color: "#9CA3AF" },
  in_progress: { label: "En cours", color: "#005CFF" },
  urgent: { label: "Urgent", color: "#EF4444" },
  done: { label: "Terminé", color: "#10B981" },
};

export const CHANTIER_TYPE_META = {
  electricite: { label: "Électricité", color: "#F59E0B", icon: "⚡" },
  climatisation: { label: "Climatisation", color: "#06B6D4", icon: "❄" },
  video: { label: "Vidéosurveillance", color: "#EF4444", icon: "📹" },
  domotique: { label: "Domotique", color: "#8B5CF6", icon: "🏠" },
  loxone: { label: "Loxone", color: "#22C55E", icon: "🎛" },
  reseau: { label: "Réseau / VDI", color: "#3B82F6", icon: "🌐" },
  alarme: { label: "Alarme", color: "#F97316", icon: "🚨" },
};

/**
 * Normalise a chantier's business domains into an array. Old records only
 * have `type: "electricite"` (single), new ones have `types: ["electricite",
 * "loxone"]` (multi). This helper returns the effective list for rendering.
 */
export function chantierTypes(chantier) {
  if (!chantier) return [];
  if (Array.isArray(chantier.types) && chantier.types.length) return chantier.types;
  if (chantier.type) return [chantier.type];
  return [];
}
